import script from '../LineItemQuantityForm';

export default { ...script, name: 'Remove' };
